import { useMutation, useQueryClient } from '@tanstack/react-query';

import { kubesoloOfflineBundleDelete } from '@api/sdk.gen';
import { KubesoloOfflineBundle } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

export function useDeleteOfflineBundleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (name: KubesoloOfflineBundle['name']) => {
      await kubesoloOfflineBundleDelete({ path: { name } });
    },
    onSuccess: () => queryClient.invalidateQueries(queryKeys.offlineBundles()),
    ...withError('Unable to remove the offline bundle'),
  });
}
